import TamanioCrud from './TamanioCrud'
export {TamanioCrud}
export default TamanioCrud
